import './maintenance.component.scss';

export default {
  template: require('./maintenance.component.html'),
  transclude: true,
  controller: function ($scope, $location, $routeParams, $interval, HealthPublicApi) {
    'ngInject';

    const refresh = () => {
      HealthPublicApi.get({}, () => {
        if ($routeParams.redirect) {
          $location.url($routeParams.redirect);
        } else {
          $location.path('/');
        }
      });
    };

    refresh();

    const promise = $interval(() => refresh(), 10000);

    $scope.$on('$destroy', () => $interval.cancel(promise));
  }
};

